<template>
    <img :src="src" :alt="alt" />
</template>

<script>
import dlsAiLight from './assets/DLS-AI.svg'

export default {
    props: {
        alt: {
            type: String,
            default: 'DLS AI'
        }
    },
    setup() {
        // Helpers
        // Only one variant ships today. When a dark-mode wordmark drops, this becomes
        // a computed that picks light vs dark based on a `variant` prop or theme inject.
        // Consumers size with Tailwind classes (e.g. class="h-7"); the wordmark's 3:1
        // aspect is preserved automatically when only height is set.
        const src = dlsAiLight

        return { src }
    }
}
</script>
